module.exports = __webpack_public_path__ + "img/backyard-alt-angle.95733d69.jpg";